import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import { STRINGS } from "../Strings";
import PageHero from "./PageHero";

// Imports zote za picha zinafanyika hapa juu pekee kwa ajili ya muundo wa huduma
import bgHeroImg from "../assets/services.jpg";
import serviceImg1 from "../assets/youth.jpg";
import serviceImg2 from "../assets/poor.jpg";
import serviceImg3 from "../assets/addicts.jpg";
import serviceImg4 from "../assets/orphans.jpg";
import serviceImg5 from "../assets/prisoners.jpg";
import serviceImg6 from "../assets/homeless.jpg";
import serviceImg7 from "../assets/disabled.jpg";
import serviceImg8 from "../assets/banner1.jpg";

export default function ServicesBanner(props) {
    const appContext = useContext(AppContext);
    const language = appContext.language || "sw";
    const s = STRINGS.servicesPage;

    const [ready, setReady] = useState(false);

    // Kuziweka picha kwenye array ili zilingane na index ya huduma husika
    const serviceImages = [
        serviceImg1, serviceImg2, serviceImg3, serviceImg4,
        serviceImg5, serviceImg6, serviceImg7, serviceImg8
    ];

    // Mzunguko wa rangi 4 kutoka kwenye root, zinarudiwa kwa huduma 5-8
    const colorSchemes = [
        { bgClass: "srv-bg-primary", textClass: "text-white", overlayClass: "srv-overlay-primary" },
        { bgClass: "srv-bg-secondary", textClass: "text-darkColor", overlayClass: "srv-overlay-secondary" },
        { bgClass: "srv-bg-surface", textClass: "text-darkColor", overlayClass: "srv-overlay-surface" },
        { bgClass: "srv-bg-dark", textClass: "text-white", overlayClass: "srv-overlay-dark" }
    ];

    async function init() {
        setReady(false);
        // Initialization if required
        setReady(true);
    }

    useEffect(() => {
        init();
    }, []);

    if (ready) {
        return (
            <div className="services-page-wrapper">
                {/* Call PageHero Component at the Top */}
                <PageHero 
                    kicker={s.hero.kicker[language]} 
                    title={s.hero.title[language]} 
                    bgImage={bgHeroImg} 
                />

                {/* Services Container Section */}
                <section className="MainBodySection py-5 backgroundColor">
                    <div className="container py-3">
                        <div className="row g-4 justify-content-center">
                            {s.items.map((item, index) => {
                                // Kupata rangi sahihi kulingana na mzunguko wa huduma 8 (Modulo 4)
                                const scheme = colorSchemes[index % 4];

                                return (
                                    <div className="col-12 mb-3" key={index}>
                                        <div className="service-rectangle-container d-flex flex-column flex-md-row overflow-hidden shadow-sm">
                                            
                                            {/* Left Side (Desktop) / Top Side (Mobile) - Image & Overlay */}
                                            <div className="service-image-side position-relative">
                                                <div 
                                                    className="service-img-bg" 
                                                    style={{ backgroundImage: `url(${serviceImages[index]})` }}
                                                ></div>
                                                {/* Overlay inayofanana na bgColor ya huduma lakini yenye opacity ya chini */}
                                                <div className={`service-image-overlay ${scheme.overlayClass}`}></div>
                                            </div>

                                            {/* Right Side (Desktop) / Bottom Side (Mobile) - Solid Content Box */}
                                            <div className={`service-content-side p-4 p-md-5 d-flex flex-column justify-content-center ${scheme.bgClass}`}>
                                                <h3 className={`title-font-bold mb-3 ${scheme.textClass}`}>
                                                    {item.title[language]}
                                                </h3>
                                                <p className={`font-regular mb-0 lh-lg ${scheme.textClass}-75`}>
                                                    {item.desc[language]}
                                                </p>
                                            </div>

                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </section>
            </div>
        );
    } else {
        return (
            <div className="container mSupportLoading d-flex justify-content-center align-items-center" style={{ height: "200px" }}>
                {getInlineLoader()}
            </div>
        );
    }
}